import { render } from "./CustomerFilters.vue?vue&type=template&id=4af45fa2&scoped=true"
import script from "./CustomerFilters.vue?vue&type=script&lang=js"
export * from "./CustomerFilters.vue?vue&type=script&lang=js"

import "./CustomerFilters.vue?vue&type=style&index=0&id=4af45fa2&scoped=true&lang=css"

import exportComponent from "/var/www/ab-front-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af45fa2"]])

export default __exports__